/**
 * Created by Alican Köker on 2018-12-19.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TimelineLite} from "gsap";
import {EdisonGameConfig} from "../EdisonGameConfig";
import {EdisonGameModuleConfig} from "../EdisonGameModuleConfig";
import {EdisonSoundConfig} from "../EdisonSoundConfig";
import {EdisonGameMode} from "../gameMode/EdisonGameMode";
import {EdisonStateReelSymbol} from "../reel/reelSymbol/EdisonStateReelSymbol";
import {EdisonParsedGameData} from "../server/data/EdisonParsedGameData";

export class EdisonReelStopPresentationController extends ReelStopPresentationController {

    private _nextMode:EdisonGameMode;
    private _lastMode:EdisonGameMode;
    private _isRandomFeatureTriggered:boolean;
    private _stackedWildModeTriggeredThisSpin:boolean;
    private _meterFSReset:boolean[] = [false, false, false, false, false];
    private _startTime:number = 0;
    private _landedScatterCount:number = 0;

    constructor(index:number) {
        super(index, "EdisonReelStopPresentationController");

        EventHandler.addEventListener(this, SpinEvent.START, (event:GameEvent) => this.onSpinStart());
        EventHandler.addEventListener(this, SpinEvent.STARTED, (event:GameEvent) => this.onSpinStarted());
    }

    private onSpinStarted():void {
        this._startTime = this.getStartTime();
    }

    private onSpinStart():void {
        if(this._nextMode !== EdisonGameMode.STACKED_RESPIN) {
            EdisonGameModuleConfig.featureController.resetRespinOverlay();

            if(this._lastMode === EdisonGameMode.STACKED_RESPIN)
                EdisonGameModuleConfig.background.currentMode = EdisonGameMode.NORMAL;
        } else {
            EdisonGameModuleConfig.respinOverlay.unTintOverlays();
        }
        this._landedScatterCount = 0;
    }

    protected parseFeatureGameData(data:EdisonParsedGameData):void {
        this._isRandomFeatureTriggered = data.randomM1WildModeTriggeredThisSpin || data.randomM2WildModeTriggeredThisSpin;
        this._meterFSReset = data.meterFSReset;
        this._stackedWildModeTriggeredThisSpin = data.stackedWildModeTriggeredThisSpin;
        this._lastMode = this._nextMode;
        this._nextMode = data.nextMode;
    }

    public onReelBounce?(data:IReelStoppedData):void {
        if(this.checkRespinOverlay(data.reelId) && (<EdisonParsedGameData>this._gameData!).mode !== EdisonGameMode.STACKED_RESPIN) {
            let sym:EdisonStateReelSymbol = <EdisonStateReelSymbol>Reels.getSymbol(data.reelId, 0);
            if(sym)
                EdisonGameModuleConfig.featureController.addOverlayToRespin(sym!.symName, data.reelId);
        }

        const isFreespin:boolean = this._gameData!.mode === EdisonGameMode.FREESPIN;
        const isRandomFeature:boolean = (<EdisonParsedGameData>this._gameData!).randomM1WildModeTriggeredThisSpin || (<EdisonParsedGameData>this._gameData!).randomM2WildModeTriggeredThisSpin;

        if(isFreespin) {
            EdisonGameModuleConfig.featureController.updateReelFreespinValue(data.reelId);
            if(this.checkMLanded(data.reelId))
                SlotGame.sound.playEffect(EdisonSoundConfig.instance.FS_M_SYM_LANDING);

        } else if(!isRandomFeature) {
            if(this.checkBugsyLanded(data.reelId)) {
                SlotGame.sound.playEffect(EdisonSoundConfig.instance.BUGSY_LANDING);
            } else if(this.checkBettyLanded(data.reelId)) {
                SlotGame.sound.playEffect(EdisonSoundConfig.instance.BETTY_LANDING);
            }
        }

        if(!(<EdisonParsedGameData>this._gameData!).stackedModeOverlay[data.reelId] && !isFreespin) {
            if(this._gameData!.scatterPositions![data.reelId] > -1) {
                if(this._landedScatterCount < 3)//minimum 3 scatters trigger FS
                    this._landedScatterCount++;

                SlotGame.sound.playEffect((<any>EdisonSoundConfig.instance)[`SCATTER_LANDING_${this._landedScatterCount}`]);
            } else {
                if(this.checkWildLanded(data.reelId))
                    SlotGame.sound.playEffect(EdisonSoundConfig.instance.WILD_LANDING);

                SlotGame.sound.playEffect(EdisonSoundConfig.instance.REELS_BOUNCE);
            }
        }


        if(data.reelId === EdisonGameConfig.instance.REELS_NUM - 1) {
            SlotGame.sound.stopEffect(EdisonSoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START);
        }
    }

    private checkWildLanded(reelId:number):boolean {
        let arr:string[] = (<EdisonParsedGameData>this._gameData!).reels[reelId].slice(1, 4);
        return arr.filter(function(x) {return x === "W"}).length > 0;
    }

    private checkBugsyLanded(reelId:number):boolean {
        let arr:string[] = (<EdisonParsedGameData>this._gameData!).reels[reelId].slice(1, 4);
        return arr.filter(function(x) {return (<string>x) === "M1"}).length === 3;
    }

    private checkBettyLanded(reelId:number):boolean {
        let arr:string[] = (<EdisonParsedGameData>this._gameData!).reels[reelId].slice(1, 4);
        return arr.filter(function(x) {return (<string>x) === "M2"}).length === 3;
    }

    private checkMLanded(reelId:number):boolean {
        let arr:string[] = (<EdisonParsedGameData>this._gameData!).reels[reelId].slice(1, 4);
        return arr.filter(function(x) {return (<string>x).charAt(0) === "M"}).length > 0;
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        let isReset:boolean = false;
        let capHitAnimationGap:number = 1.2;
        let capHitAnimationEndDelay:number = 2;
        let numberOfCapHits:number = this._meterFSReset.filter(function(x) {return x}).length;
        let tl:TimelineLite = new TimelineLite();

        const isCurrentModeFreespin:boolean = (<EdisonParsedGameData>this._gameData)!.mode === EdisonGameMode.FREESPIN;
        const isNextModeFreespin:boolean = (<EdisonParsedGameData>this._gameData)!.nextMode !== EdisonGameMode.FREESPIN;
        const isCurrentModeNormal:boolean = this._gameData!.mode === EdisonGameMode.NORMAL;
        const isCurrentModeRespin:boolean = (<EdisonParsedGameData>this._gameData)!.mode === EdisonGameMode.STACKED_RESPIN;
        const isThereWin:boolean = (<EdisonParsedGameData>this._gameData)!.singleWin > 0;
        const isRandomFeatureTriggered:boolean = (<EdisonParsedGameData>this._gameData)!.randomM1WildModeTriggeredThisSpin ||
            (<EdisonParsedGameData>this._gameData)!.randomM2WildModeTriggeredThisSpin;

        if(data.reelId === EdisonGameConfig.instance.REELS_NUM - 1) { /**last reel*/

            if(isRandomFeatureTriggered) {
                SlotGame.sound.stopEffect(EdisonSoundConfig.instance.FS_ANTICIPATION);
                if(!isThereWin) {
                    SlotGame.sound.playEffect(EdisonSoundConfig.instance.ANTICIPATION_FAIL);
                }
            }

            if(isCurrentModeNormal && this._gameData!.freespinTriggeredThisSpin) {
                EdisonGameModuleConfig.featureController.startFreespin();
            }

            if(isCurrentModeRespin) {
                if(!isThereWin) {
                    EdisonGameModuleConfig.background.currentMode = "normal";

                    SlotGame.sound.fadeAmbience(0, 1000);
                    SlotGame.sound.playEffect(EdisonSoundConfig.instance.ANTICIPATION_FAIL);
                    tl.add(() => {
                        SlotGame.sound.playAmbience(EdisonSoundConfig.instance.MAIN_GAME_AMBIANCE);
                        SlotGame.sound.fadeAmbience(1, 1000);
                    }, .7);
                } else {
                    let tl:TimelineLite = new TimelineLite();
                    tl.add(() => {
                        SlotGame.sound.playAmbience(EdisonSoundConfig.instance.MAIN_GAME_AMBIANCE);
                    }, 1);
                }
            }

            if(this.checkRespinCondition()) {
                EdisonGameModuleConfig.featureController.startRespinFeature();
            }

            if(numberOfCapHits > 0) {
                tl.add(() => {
                    this.dispatchCompleteEvent(data.reelId);
                }, numberOfCapHits * capHitAnimationGap + capHitAnimationEndDelay);
                isReset = true;
            }

            if(!isReset) {

                const initialWPDelay:number = this._gameData && isCurrentModeFreespin && isThereWin ? 1 : 0;

                tl.add(() => {
                    this.dispatchCompleteEvent(data.reelId);
                }, initialWPDelay);
            }

            if(isCurrentModeFreespin) {

                if(isNextModeFreespin && !isThereWin)
                    tl.add(() => EdisonGameModuleConfig.freespinController.deactivateFreespinOverlay(), .5);
            }
        } else {
            this.dispatchCompleteEvent(data.reelId);
        }
    }

    private checkRespinCondition():boolean {
        return this._gameData!.nextMode === EdisonGameMode.STACKED_RESPIN && this._gameData!.singleWin <= 0;
    }

    private checkRespinOverlay(reelId:number):boolean {
        return (<EdisonParsedGameData>this._gameData).stackedModeOverlay[reelId];
    }

    private getStartTime():number {
        return new Date().getTime();
    };

}